import { supabase } from '../lib/supabase';

const SITE_URL = import.meta.env?.VITE_SUPABASE_URL
  ? window.location?.origin
  : 'http://localhost:5173';

/**
 * Send a Slack notification when tournament results are published.
 * @param {object} params
 * @param {string} params.tournamentId
 * @param {string} params.tournamentName
 * @param {string} [params.winnerName]
 * @param {number} [params.totalParticipants]
 * @param {string} [params.message]
 */
export async function notifySlackResultsPublished({
  tournamentId,
  tournamentName,
  winnerName,
  totalParticipants,
  message,
}) {
  try {
    const { data, error } = await supabase?.functions?.invoke('send-slack-notification', {
      body: {
        type: 'results_published',
        tournamentId,
        tournamentName,
        winnerName,
        totalParticipants,
        message,
        siteUrl: SITE_URL,
      },
    });

    if (error) {
      console.error('Slack notification error (results_published):', error);
      return { success: false, error };
    }

    return { success: true, data };
  } catch (err) {
    console.error('Failed to send Slack results notification:', err);
    return { success: false, error: err };
  }
}

/**
 * Send a Slack deadline reminder manually (optional, for admin use).
 * @param {object} params
 * @param {string} params.matchId
 * @param {string} params.matchName
 * @param {string} params.tournamentName
 * @param {string} [params.venue]
 * @param {string} [params.matchTime]
 * @param {number} [params.minutesRemaining]
 * @param {number} [params.pendingCount]
 */
export async function notifySlackDeadlineReminder({
  matchId,
  matchName,
  tournamentName,
  venue,
  matchTime,
  minutesRemaining = 30,
  pendingCount,
}) {
  try {
    const { data, error } = await supabase?.functions?.invoke('send-slack-notification', {
      body: {
        type: 'deadline_reminder',
        matchId,
        matchName,
        tournamentName,
        venue,
        matchTime,
        minutesRemaining,
        pendingCount,
        siteUrl: SITE_URL,
      },
    });

    if (error) {
      console.error('Slack notification error (deadline_reminder):', error);
      return { success: false, error };
    }

    return { success: true, data };
  } catch (err) {
    console.error('Failed to send Slack deadline notification:', err);
    return { success: false, error: err };
  }
}
